import { render, staticRenderFns } from "./BorrarBaseEmail.vue?vue&type=template&id=eb4db2e0"
import script from "./BorrarBaseEmail.vue?vue&type=script&lang=js"
export * from "./BorrarBaseEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports